import { __assign } from "tslib";
import * as React from 'react';
import { getSolutionPreviewBySlugOrId } from '../../api/api';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { dtoToShareAppProps, ShareApp } from './share-app';
import { CenteredLoader } from '../centered-loader';
import { useConfigContext } from '../../config-context';
export var ShareAppContainer = function (_a) {
    var appDefId = _a.appDefId, shareId = _a.shareId;
    var locale = useConfigContext().locale;
    var dataFetcher = function () {
        return getSolutionPreviewBySlugOrId(appDefId, locale, true).then(function (data) { return data; });
    };
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: dataFetcher, fetchMemoizationId: "share-app-" + locale }, function (_a) {
        var fetchData = _a.fetchData;
        return (React.createElement(ShareApp, __assign({}, dtoToShareAppProps(fetchData, shareId))));
    }));
};
//# sourceMappingURL=share-app-container.js.map